import { Paper, Stack, Box } from '@mui/material'
import Button from '@mui/material/Button'
import { createTemplate, editTemplate, fetchTemplate } from './api'
import { useForm } from 'react-hook-form'
import { InputText } from '../../common/LetterForms/InputText'
import { InputDropdownGroup } from '../../common/LetterForms/InputDropdownGroup'
import { templateTypeOptions } from './data/template-type'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { TextEditor } from '../../common/LetterForms/TextEditor'

const formStyle = {
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
}

export const LetterTemplatesEdit = ({ isEdit }) => {
  const [templateToEdit, setTemplateToEdit] = useState(null)
  const { template_id } = useParams()
  const navigate = useNavigate()
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      name: '',
      type: '',
      body: '',
    },
  })

  useEffect(() => {
    if (templateToEdit && isEdit) {
      setValue('name', templateToEdit.name)
      setValue('type', templateToEdit.type)
      setValue('body', templateToEdit.body)
    }
  }, [templateToEdit, isEdit])

  useEffect(() => {
    if (isEdit && template_id) {
      fetchTemplate(template_id).then((res) => setTemplateToEdit(res))
    }
  }, [])

  const onSubmit = async (data) => {
    if (isEdit && templateToEdit) {
      await editTemplate(data, templateToEdit.id)
    } else {
      await createTemplate(data)
    }
    navigate('/send-letter')
  }

  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: 'background.default',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Paper
        elevation={2}
        sx={{
          width: '80%',
          p: 4,
        }}
      >
        <h1>{isEdit ? 'Modification de template' : 'Création de template'}</h1>
        <form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
          <InputText
            name={'name'}
            control={control}
            label={'Nom du template'}
            required={!templateToEdit}
          />
          <InputDropdownGroup
            name={'type'}
            control={control}
            label={'Type'}
            required={!templateToEdit}
            options={templateTypeOptions}
          />
          <Stack sx={{ mb: 3 }} spacing={2}>
            <TextEditor
              fieldName="body"
              label="Contenu"
              control={control}
              required={!templateToEdit}
            />
          </Stack>
          <Button type="submit" variant="contained" color="primary">
            {isEdit ? 'Modifier un template' : 'Créer un template'}
          </Button>
        </form>
      </Paper>
    </Box>
  )
}
